<template>
  <article v-if="charged">
    <section class="table_card mb-5">
      <div class="table_card__head">
        <v-layout row wrap>
          <v-flex lg9>
            <p class="table_card__head--title">Crear Inmueble</p>
            <v-breadcrumbs class="breadcums">
              <v-icon slot="divider">chevron_right</v-icon>
              <v-breadcrumbs-item
                @click="$router.push({name: 'location_edit', params: {id: originalLocation.id}})"
                class="breadcums__option">
                {{originalLocation.name}}
              </v-breadcrumbs-item>

              <v-breadcrumbs-item
                disabled
                class="breadcums__disable">
                {{sublocation.attributes.name.length>0?sublocation.attributes.name:"Crear Inmueble"}}
              </v-breadcrumbs-item>
            </v-breadcrumbs>
          </v-flex>
          <v-flex lg3 class="filter_options">
            <v-flex class="right mr-0">
              <button
                class="faccess_button px-5"
                :disabled="formIsInError"
                @click="formIsInError?'':createLocation()"
              >
                Crear Inmueble
              </button>
            </v-flex>
          </v-flex>
        </v-layout>
      </div>
        <!-- <div
          :class="formIsInError?'data_card__create_button--solid--error':'data_card__create_button--solid'"
          @click="formIsInError?'':createLocation()">
          Crear sublocación
        </div> -->

      <div class="table_card__body">
        <v-layout row wrap>
          <v-flex xs12>
            <v-flex xs12 lg6 class="pr-3 mb-3">
              <span class="data_card__info--label">Seleccionar locación</span>
              <v-select
                label="Seleccionar sede"
                :items="locations"
                item-value="id"
                item-text="name"
                v-model="sublocation.attributes.location_id"
                single-line
                dense
                solo
                color="blue bold"
              ></v-select>
            </v-flex>
            <v-flex xs12 lg6 class="pr-3 mb-3">
              <span class="data_card__info--label" style="white-space: nowrap;">Nombre del inmueble</span>
              <input
                class="faccess_input"
                type="text"
                name="Name"
                placeholder="Nombre del inmueble"
                v-model="sublocation.attributes.name">
            </v-flex>
            <v-flex xs12 lg6 class="pr-3 mb-4">
              <span class="data_card__info--label" style="white-space: nowrap;">Propietario Asignado</span>
              <div style="display: flex; align-items: center; margin-top: 5px;">
                <div
                  class="faccess_input"
                  style="margin: 0; display: flex; align-items: center;">
                  {{ user_name }}
                </div>
                <v-btn
                  v-show="!selecting_primary_user"
                  style="background-color: #1476FB; color: white;"
                  class="v-btn ml-3"
                  @click="activeUserSelection('primary_user')">
                  Editar
                </v-btn>
              </div>
            </v-flex>
            <v-flex xs12 lg6 class="pr-3 mb-3">
              <span class="data_card__info--label" style="white-space: nowrap;">Usuarios Relacionados</span>
              <div style="display: flex; margin-top: 5px;">
                <div
                  class="faccess_input"
                  style="margin: 0; padding-bottom: 0; display: flex; flex-direction: column; height: 130px; overflow-y: auto;">

                  <span
                    v-for="assigned_user in assigned_user_names"
                    style="margin-bottom: 10px;">
                    - {{ assigned_user}}
                  </span>
                </div>
                <v-btn
                  v-show="!selecting_assigned_users"
                  style="background-color: #1476FB; color: white;"
                  class="v-btn ml-3"
                  @click="activeUserSelection('assigned_users')">
                  Editar
                </v-btn>
              </div>
            </v-flex>
          </v-flex>
        </v-layout>
      </div>
    </section>

    <section class="table_card mb-5" v-show="selecting_primary_user || selecting_assigned_users">
      <div class="table_card__head">
        <v-layout row wrap fill-height>
          <v-flex xs12 lg6 class="head_contain">
            <p class="table_card__head--title">
              {{ selecting_primary_user ? 'Seleccionar propietario asignado' : 'Seleccionar usuarios relacionados' }}
            </p>
          </v-flex>
          <v-flex xs12 lg6 class="filter_options">
            <v-flex class="right">
              <input
                type="text"
                placeholder="Buscar"
                class="input_solid"
                v-model="options_table.search"
              >
              <img
                src="@/assets/img/icons/search-icon.svg"
                class="button_search"
              >
            </v-flex>
            <div
              class="buttom_reload"
              @click="selecting_primary_user ? getUsersForSublocation() : getUsersToNotifySublocation()"
            >
              <img src="@/assets/img/icons/refresh-icon.svg">
            </div>
          </v-flex>
        </v-layout>
      </div>

      <div>

        <v-data-table
          v-model="users"
          :headers="options_table.headers_table"
          :items="filteredUsers"
          :search="options_table.search"
          :pagination.sync="options_table.pagination"
          hide-actions
        >
          <template slot="headers" slot-scope="props">
            <tr>
              <th></th>
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="['column sortable', options_table.pagination.descending ? 'desc' : 'asc', header.value === options_table.pagination.sortBy ? 'active' : '']"
                @click="changeSort(header.value)"
              >
                <v-icon small>arrow_upward</v-icon>
                {{ header.text }}
              </th>
            </tr>
          </template>
          <template slot="items" slot-scope="props">
            <tr>
              <td>
                <v-checkbox
                  :input-value="(selecting_primary_user && sublocation.attributes.user_id == props.item.id) ||
                                (selecting_assigned_users && sublocation.attributes.assigned_users.includes(props.item.id))"
                  color="#1476FB"
                  hide-details
                  @change="selectUser(props.item)"
                ></v-checkbox>
              </td>
              <td class="text-xs-center" width="180px">{{ props.item.rut }}</td>
              <td class="text-xs-center">{{ props.item.name }}</td>
            </tr>
          </template>
        </v-data-table>
        <div class="text-xs-center pt-2">
          <v-pagination :value ="page" :length="pages" @input="changePage"></v-pagination>
        </div>
      </div>
    </section>
  </article>
</template>

<script>
import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue'

export default {
  data(){
    return{
      options_table:{
        pagination: {
          sortBy: 'name',
          rowsPerPage: 20
        },
        headers_table:[
          {
            text: 'N° Documento',
            align: 'center',
            value: 'rut'
          },
          {
            text: 'Nombre Usuario',
            align: 'center',
            value: 'name'
          }
        ],
        filters: {
          rut: [],
          name: [],
        },
      },
      sublocation_id: '',
      users: [],
      users_for_select:[],
      users_to_notify_sublocation_for_select: [],
      right_now: true,
      selecting_primary_user: false,
      selecting_assigned_users: false,
      page: 0,
      pages: 1,
      user_name: "",
      assigned_user_names: [],
      locations: [],
      sublocation: {
        attributes:{
          location_id:0,
          name: '',
          user_id: null,
          assigned_users: []
          // email: '',
          // mobile: ''
        }
      },
      actual_day:"monday",
      errorEnding:false,
      errorOpening:false,
      charged: false,
      originalLocation:{
        id:0,
        name:'Sublocation'
      } ,
      days: {
        monday:     {name: 'monday',
                     begin:'',
                     end:'',
                     max_spaces:0,
                     spaces_per_booking:0,
                     frequency:"0:00",
                     stay_time:"0:00",
                     type:'string',
                     name_esp: 'lunes',
                     inactive_times: []
                    },
        tuesday:    {name: 'tuesday',
                     begin:'',
                     end:'',
                     max_spaces:0,
                     spaces_per_booking:0,
                     frequency:"0:00",
                     stay_time:"0:00",
                     type:'string',
                     name_esp: 'martes',
                     inactive_times: []
                    },
        wednesday:  {name: 'wednesday',
                     begin:'',
                     end:'',
                     max_spaces:0,
                     spaces_per_booking:0,
                     frequency:"0:00",
                     stay_time:"0:00",
                     type:'string',
                     name_esp: 'miércoles',
                     inactive_times: []
                    },
        thursday:   {name: 'thursday',
                     begin:'',
                     end:'',
                     max_spaces:0,
                     spaces_per_booking:0,
                     frequency:"0:00",
                     stay_time:"0:00",
                     type:'string',
                     name_esp: 'jueves',
                     inactive_times: []
                    },
        friday:     {name: 'friday',
                     begin:'',
                     end:'',
                     max_spaces:0,
                     spaces_per_booking:0,
                     frequency:"0:00",
                     stay_time:"0:00",
                     type:'string',
                     name_esp: 'viernes',
                     inactive_times: []
                    },
        saturday:   {name: 'saturday',
                     begin:'',
                     end:'',
                     max_spaces:0,
                     spaces_per_booking:0,
                     frequency:"0:00",
                     stay_time:"0:00",
                     type:'string',
                     name_esp: 'sábado',
                     inactive_times: []
                    },
        sunday:     {name: 'sunday',
                     begin:'',
                     end:'',
                     max_spaces:0,
                     spaces_per_booking:0,
                     frequency:"0:00",
                     stay_time:"0:00",
                     type:'string',
                     name_esp: 'domingo',
                     inactive_times: []
                    }
      },
      timeBoxes:{
        monday:     {
                     begin:"12:00 am",
                     end:"12:00 am",
                     frequency:"0 h 00",
                     stay_time:"0 h 00",
                    },
        tuesday:    {
                     begin:"12:00 am",
                     end:"12:00 am",
                     frequency:"0 h 00",
                     stay_time:"0 h 00",
                    },
        wednesday:  {
                     begin:"12:00 am",
                     end:"12:00 am",
                     frequency:"0 h 00",
                     stay_time:"0 h 00",
                    },
        thursday:   {
                     begin:"12:00 am",
                     end:"12:00 am",
                     frequency:"0 h 00",
                     stay_time:"0 h 00",
                    },
        friday:     {
                     begin:"12:00 am",
                     end:"12:00 am",
                     frequency:"0 h 00",
                     stay_time:"0 h 00",
                    },
        saturday:   {
                     begin:"12:00 am",
                     end:"12:00 am",
                     frequency:"0 h 00",
                     stay_time:"0 h 00",
                    },
        sunday:     {
                     begin:"12:00 am",
                     end:"12:00 am",
                     frequency:"0 h 00",
                     stay_time:"0 h 00",
                    }
      },
      maximum_spaces:{
      monday: 0,
      tuesday: 0,
      wednesday: 0,
      thursday: 0,
      friday:0,
      saturday:0,
      sunday:0
      },
      spacesInError:false,
      validate_quota: false,
      country: '',
      time_zone: '',
      location_time_zone: '',
      gtm: '',
      max_hh_minutes: 0,
      book_hh_minutes: 0,
      max_mm: 0,
      book_mm: 0,
      time_stay: 0,
      book_every: 0,
      book_every_minutes: 0,
      invalid_inactive_times: false
    }
  },
  components: { VueTimepicker },
  computed:{
    filteredUsers(){
      if(this.selecting_primary_user){
        return this.users_for_select.filter(d => {
          return Object.keys(this.options_table.filters).every(f => {
            return this.options_table.filters[f].length < 1 || this.options_table.filters[f].includes(d[f])
          })
        })
      } else if(this.selecting_assigned_users){
        return this.users_to_notify_sublocation_for_select.filter(d => {
          return Object.keys(this.options_table.filters).every(f => {
            return this.options_table.filters[f].length < 1 || this.options_table.filters[f].includes(d[f])
          })
        })
      }
    },
    formIsInError(){
      var ans=false
      if(this.scheduleIsInError||this.sublocation.attributes.name.length==0||this.spacesInError||this.invalid_inactive_times){
        ans=true
      }
      return ans
    },
    timeZoneLocal: function(){
      let resolvedOptions = Intl.DateTimeFormat().resolvedOptions()
      return resolvedOptions.timeZone
    },
  },
  mounted(){
    var path = this.$route.params.id
    var self=this;
    try {
      this.$http.get('locations_schedule',{
          headers:{
            "X-Device-ID": this.getDeviceId(),
            "Authorization": 'Bearer ' + this.getUserToken()
          }
      })
      .then(function(response){
        console.log('===locations_schedule=== ', response)
        this.locations = response.body.locations
        let myOriginalLocation=this.locations.find(element => element.id == path)
        this.originalLocation.id= myOriginalLocation.id
        this.originalLocation.name=myOriginalLocation.name
        this.sublocation.attributes.location_id=myOriginalLocation.id
        var myLoc=this.locations.find(element => element.id == self.sublocation.attributes.location_id)
        Object.keys(this.maximum_spaces).forEach(x=>this.maximum_spaces[x]= myLoc.schedule && myLoc.occupied_spaces ? myLoc.schedule[x].max_spaces-myLoc.occupied_spaces[x] : 0)
          // this.timeBoxes[new_schedules[i][0]].stay_time=this.convertDurationToStyleFormat(this.days[new_schedules[i][0]].stay_time)
          // var max=this.locations.find(element => element.id == self.sublocation.attributes.location_id).schedule[new_schedules[i][0]].max_spaces
          // var used=this.locations.find(element => element.id == self.sublocation.attributes.location_id).occupied_spaces[new_schedules[i][0]]
          // let myTotalDaySpaces=max-used+Number(this.days[new_schedules[i][0]].max_spaces)
          // this.maximum_spaces[new_schedules[i][0]]=myTotalDaySpaces
       this.charged = true;
       var myDays = myLoc.get_data
       this.country = myLoc.country
       this.time_zone = myLoc.time_zone
       /* console.log('time_zone  ', this.time_zone)  */
       this.location_time_zone = myLoc.time_zone.substring(myLoc.time_zone.indexOf('/') + 1,myLoc.time_zone.length).replace(/[_]/g,' ')
       this.gtm = myLoc.gtm.substring(0,3) + ":" + myLoc.gtm.substring(3,5)/* .replace(/[0]/g,'')  */
       var new_schedules = Object.entries(myDays)
      for (var i = 0; i < new_schedules.length; i++) {
        try {
          let hh_1 = ''
          let mm_1 = ''
          let h1 = String(new_schedules[i][1].beginning.hour)
          h1.length === 1 ? hh_1 = '0' + h1 : hh_1 = h1
          let m1 = String(new_schedules[i][1].beginning.minute)
          m1.length === 1 ? mm_1 = '0' + m1 : mm_1 = m1
          let beginning = hh_1 + ":" + mm_1
          let hh_2 = ''
          let mm_2 = ''
          let h2 = String(new_schedules[i][1].ending.hour)
          h2.length === 1 ? hh_2 = '0' + h2 : hh_2 = h2
          let m2 = String(new_schedules[i][1].ending.minute)
          m2.length === 1 ? mm_2 = '0' + m2 : mm_2 = m2
          let ending = hh_2 + ":" + mm_2
          this.days[new_schedules[i][0]].begin = beginning
          this.days[new_schedules[i][0]].end = ending
          this.timeBoxes[new_schedules[i][0]].begin=this.convertHourToStyleFormat(this.days[new_schedules[i][0]].begin)
          this.timeBoxes[new_schedules[i][0]].end=this.convertHourToStyleFormat(this.days[new_schedules[i][0]].end)
        } catch (error) {

        }
      }
      this.setNewSpaces();
      this.charged = true

      }, function(response){
        if(response.body.meta != undefined && response.body.meta != null){
          if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
            this.checkToken(response.body.meta.authentication_token)
          }
        }
        if(typeof response.body.errors[0].details != "object"){
          alert(response.body.errors[0].details);
        }else{
          let message = []
          for(var key in response.body.errors[0].details){
            message.push(response.body.errors[0].details[key])
          }
          alert(message);
        }
      })
      } catch (e) {
        alert(e.message)
      }
    this.getUsersForSublocation()
    this.getUsersToNotifySublocation()
  },
  methods:{
    selectUser({id, name}){
      if(this.selecting_primary_user){
        if(this.sublocation.attributes.user_id != id){
          this.selecting_primary_user = false
          this.sublocation.attributes.user_id = id
          this.user_name = name

        } else {
          this.sublocation.attributes.user_id = null
          this.user_name = ''
        }

      } else if(this.selecting_assigned_users){
        if(!this.sublocation.attributes.assigned_users.includes(id)){
          this.sublocation.attributes.assigned_users.push(id)
          this.assigned_user_names.push(name)

        } else {
          this.sublocation.attributes.assigned_users.splice(this.sublocation.attributes.assigned_users.indexOf(id), 1)
          this.assigned_user_names.splice(this.assigned_user_names.indexOf(name), 1)
        }
      }
    },
    getUsersForSublocation(){
      try {
        this.$http.get('app/sublocations/get_active_users_for_sublocation',{
          params: {
            page: this.page,
            company_id: this.getCompany().id
          },

          headers: {
            "X-Device-ID" : this.getDeviceId(),
           "Authorization" : 'Bearer ' + this.getUserToken()
          }
        })
        .then(function(response){
          this.users_for_select = response.body.data
          this.pages = response.body.meta.pages
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        })
      } catch (e) {
        alert(e.message)
      }
    },
    getUsersToNotifySublocation(){
      try {
        this.$http.get('app/sublocations/users_to_notify_sublocation',{
          params: {
            company_id: this.getCompany().id,
            page: this.page
          },

          headers: {
            "X-Device-ID" : this.getDeviceId(),
            "Authorization" : 'Bearer ' + this.getUserToken()
          },
        })
        .then(function(response){
          this.users_to_notify_sublocation_for_select = response.body.data
          this.pages = response.body.meta.pages
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        })
      } catch (e) {
        alert(e.message)
      }
    },
    changeLocation(){
      console.log("AHAH")
    },
    isNumberValid(evt){
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            evt.preventDefault();;
        }else {
            return true;
        }
    },
    createLocation(){
      // this.checkSchedule()
      this.setDaysWithNewTimes();
      this.sublocation.attributes.sublocation_schedule_attributes = this.days

      try {
        this.$http.post('sublocations/', {data: this.encrypt(this.sublocation).toString()},
          {headers:
            {"X-Device-ID" : this.getDeviceId(),
             "Authorization" : 'Bearer ' + this.getUserToken()}})
        .then(function(response){
          console.log('=== New_sublocations === ', response)
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
          this.$router.push({name: 'location_edit', params: {id: response.data.data.attributes.location_id}})
          this.updateAlertMessage("Inmueble creado correctamente")
          this.updateIsInAlert(true)
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
          if(typeof response.body.errors[0].details != "object"){
            alert(response.body.errors[0].details);
          }else{
            let message = []
            for(var key in response.body.errors[0].details){
              message.push(response.body.errors[0].details[key])
            }
            alert(message);
          }
        })
      } catch (e) {
        alert(e.message)
      }
    },
    activeUserSelection(ref){
      if(ref == 'primary_user'){
        this.selecting_primary_user = true
        this.selecting_assigned_users = false

      } else if(ref == 'assigned_users'){
        this.selecting_assigned_users = true
        this.selecting_primary_user = false
      }

      scrollTo(0, 700)
      this.changePage(1)
    },
    convertHourToStyleFormat(hour){
      var arr=hour.split(":")
      var amOrPm="am"
      if(arr[0]>=12){
        amOrPm="pm"
        if(arr[0]>12){
          arr[0]= Number(arr[0])%12
        }
      }else if(arr[0]==0){
        arr[0]=12
      }
      if(Number(arr[0])<10){
        arr[0]="0"+Number(arr[0]).toString()
      }
      return arr[0]+":"+arr[1]+" "+amOrPm;
    },
    convertDurationToStyleFormat(hour){
      var arr=hour.split(":")
      return arr[0]+" h "+arr[1].toString().padStart(2,"0");
    },
    setDaysWithNewTimes(){
      var myConversion=function convertStyleFormatToHour(hour){
        var arr=hour.split(":")
        let hours=Number(arr[0])
        let secondArr=arr[1].split(" ")
        var minutes=secondArr[0]
        var amOrPm=secondArr[1]
        var finalHour=[hours,minutes]

        if(amOrPm=="pm" && hours!=12){
          finalHour[0]= (Number(hours)+12)%24
        }else if(hours==12 && amOrPm=="am" ){
          finalHour[0]=0
        }
        return finalHour[0].toString().padStart(2,"0")+":"+finalHour[1].toString().padStart(2,"0");
      }
      var myHourConversion= function convertFormatToSend(time){
        let arr=time.split(" h ")
        return arr[0]+":"+arr[1].toString().padStart(2,"0");
      }
      for(var key in this.timeBoxes){
        this.days[key].begin=myConversion(this.timeBoxes[key].begin);
        this.days[key].end=myConversion(this.timeBoxes[key].end);
        this.days[key].frequency=myHourConversion(this.timeBoxes[key].frequency);
        this.days[key].stay_time=myHourConversion(this.timeBoxes[key].stay_time);

        this.days[key].inactive_times.forEach((value, index) => {
          value.start_time = myConversion(value.start_time);
          value.end_time = myConversion(value.end_time);
        });
      }
    },
    addInactiveTime(day_name){
      var inactiveTime = {
        weekday: day_name,
        start_time: this.timeBoxes[day_name].begin,
        end_time: this.timeBoxes[day_name].begin,
        errorStart: false,
        errorEnd: false
      }
      this.days[day_name].inactive_times.push(inactiveTime);
    },
    changeSort (column) {
      if (this.options_table.pagination.sortBy === column) {
        this.options_table.pagination.descending = !this.options_table.pagination.descending
      } else {
        this.options_table.pagination.sortBy = column
        this.options_table.pagination.descending = false
      }
    },
    changePage(page){
      this.page = page

      if(this.selecting_primary_user) this.getUsersForSublocation()
      else if(this.selecting_assigned_users) this.getUsersToNotifySublocation()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/locations/sublocations/CreateSublocationFromLocation.vue